import React, { useEffect, useRef, useState } from 'react';

export default function Projects() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  const projects = [
    {
      title: 'PS Gallery',
      description: 'A modern image gallery application built with TypeScript and React, featuring beautiful UI, image management, and seamless user experience. Deployed on Vercel.',
      image: `${process.env.PUBLIC_URL}/images/download.png`,
      github: 'https://github.com/selvarajane/psgallery.git',
      demo: 'https://psgallery.vercel.app/'
    },
    {
      title: 'Task Management System',
      description: 'Collaborative task management application built with React and Flask, featuring real-time updates and team collaboration tools.',
      image: 'https://images.pexels.com/photos/3183150/pexels-photo-3183150.jpeg?auto=compress&cs=tinysrgb&w=600',
      github: 'https://github.com/selvarajane',
      demo: 'https://demo-taskmanager.com'
    },
    {
      title: 'Portfolio Dashboard',
      description: 'Interactive analytics dashboard with data visualization using React, Chart.js, and Python backend for data processing.',
      image: 'https://images.pexels.com/photos/265087/pexels-photo-265087.jpeg?auto=compress&cs=tinysrgb&w=600',
      github: 'https://github.com/selvarajane',
      demo: 'https://demo-dashboard.com'
    },
    {
      title: 'Weather Forecast App',
      description: 'Modern weather application with geolocation support, 7-day forecasts, and beautiful UI built with React and OpenWeather API.',
      image: 'https://images.pexels.com/photos/1118873/pexels-photo-1118873.jpeg?auto=compress&cs=tinysrgb&w=600',
      github: 'https://github.com/selvarajane',
      demo: 'https://demo-weather.com'
    },
    {
      title: 'Social Media Dashboard',
      description: 'Social media management tool with analytics, scheduling, and multi-platform support using React and Django REST framework.',
      image: 'https://images.pexels.com/photos/267350/pexels-photo-267350.jpeg?auto=compress&cs=tinysrgb&w=600',
      github: 'https://github.com/selvarajane',
      demo: 'https://demo-social.com'
    },
    {
      title: 'Fitness Tracker',
      description: 'Comprehensive fitness tracking application with workout plans, progress tracking, and nutrition monitoring using React and Python.',
      image: 'https://images.pexels.com/photos/4162491/pexels-photo-4162491.jpeg?auto=compress&cs=tinysrgb&w=600',
      github: 'https://github.com/selvarajane',
      demo: 'https://demo-fitness.com'
    }
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section id="projects" className="projects-section" ref={sectionRef}>
      <div className="container">
        <h2 className="section-title">Projects</h2>
        <div className={`projects-grid ${isVisible ? 'visible' : ''}`}>
          {projects.map((project, index) => (
            <div
              className="project-card"
              key={index}
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="project-image">
                <img src={project.image} alt={project.title} />
                <div className="project-overlay">
                  <a href={project.github} target="_blank" rel="noopener noreferrer" className="project-link">
                    <i className="fab fa-github"></i>
                  </a>
                  <a href={project.demo} target="_blank" rel="noopener noreferrer" className="project-link">
                    <i className="fas fa-external-link-alt"></i>
                  </a>
                </div>
              </div>
              <div className="project-content">
                <h3>{project.title}</h3>
                <p>{project.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
